/**
 * 各デバイスのブレークポイント
 * @see src\scss\global\setting\_var.scss
 */
export const breakPoint = {
  'sumaho': 560 + 1,
  'tablet': 960 + 1,
  'note': 1440 + 1,
  'pc': 1920 + 1,
};
